export default {
  terms: {
    badge: 'NUTZUNGSBEDINGUNGEN',
    title: 'Allgemeine Geschäftsbedingungen',
    updated: 'Zuletzt aktualisiert: September 2026',
    sections: [
      {
        title: '1. Gegenstand',
        blocks: [
          { type: 'p', text: 'Diese Allgemeinen Geschäftsbedingungen regeln den Zugang zur und die Nutzung der Website von Limpia Sàrl.' },
          { type: 'p', text: 'Durch den Zugriff auf diese Website bestätigt der Nutzer, diese Bedingungen gelesen zu haben und sie zu akzeptieren.' },
          { type: 'p', text: 'Ziel der Website ist es, die Tätigkeiten, Leistungen und Dienstleistungen von Limpia Sàrl vorzustellen sowie Besuchern die Möglichkeit zu geben, mit dem Unternehmen in Kontakt zu treten.' },
        ],
      },
      {
        title: '2. Auf der Website dargestellte Informationen',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl bemüht sich, genaue, aktuelle und vollständige Informationen über ihre Dienstleistungen bereitzustellen.' },
          { type: 'p', text: 'Die auf der Website veröffentlichten Informationen dienen jedoch nur zu Informationszwecken und können jederzeit ohne vorherige Ankündigung geändert werden.' },
          { type: 'p', text: 'Limpia Sàrl übernimmt keine Gewähr dafür, dass alle auf der Website verfügbaren Informationen stets fehlerfrei, vollständig oder aktuell sind.' },
        ],
      },
      {
        title: '3. Kontakt- und Angebotsanfragen',
        blocks: [
          { type: 'p', text: 'Die auf der Website verfügbaren Formulare oder Kontaktdaten ermöglichen es Nutzern, Limpia Sàrl zu kontaktieren oder Informationen zu ihren Leistungen anzufordern.' },
          { type: 'p', text: 'Das Absenden einer Anfrage über die Website stellt nicht automatisch einen Vertragsabschluss dar.' },
          { type: 'p', text: 'Jede Dienstleistungserbringung setzt eine Vereinbarung zwischen Limpia Sàrl und dem Kunden sowie gegebenenfalls ein vom Kunden angenommenes Angebot oder eine Offerte voraus.' },
          { type: 'p', text: 'Die vom Nutzer bereitgestellten Informationen müssen korrekt und vollständig sein, damit Limpia Sàrl die Anfrage ordnungsgemäss bearbeiten kann.' },
        ],
      },
      {
        title: '4. Geistiges Eigentum',
        blocks: [
          { type: 'p', text: 'Sofern nicht anders angegeben, sind sämtliche Inhalte dieser Website, insbesondere Texte, Logos, Fotografien, Grafiken, visuelle Elemente, Designs und sonstige Inhalte, durch die anwendbaren Bestimmungen zum geistigen Eigentum geschützt.' },
          { type: 'p', text: 'Jede Vervielfältigung, Änderung, Verbreitung, Veröffentlichung oder kommerzielle Nutzung der Website-Inhalte ohne vorherige Genehmigung von Limpia Sàrl ist untersagt, soweit diese Nutzung nicht gesetzlich gestattet ist.' },
        ],
      },
      {
        title: '5. Nutzung der Website',
        blocks: [
          { type: 'p', text: 'Der Nutzer verpflichtet sich, die Website rechtmässig und im Einklang mit diesen Bedingungen zu nutzen.' },
          { type: 'p', text: 'Insbesondere ist Folgendes untersagt:' },
          { type: 'li', text: 'die Website zu illegalen Zwecken zu nutzen;' },
          { type: 'li', text: 'unbefugt auf die Systeme oder Server der Website zuzugreifen;' },
          { type: 'li', text: 'schädliche Inhalte oder Inhalte zu übermitteln, die die Website beschädigen könnten;' },
          { type: 'li', text: 'die Informationen der Website in einer Weise zu nutzen, die die Rechte von Limpia Sàrl oder Dritter verletzen könnte.' },
        ],
      },
      {
        title: '6. Verfügbarkeit der Website',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl bemüht sich, ihre Website zugänglich und funktionsfähig zu halten.' },
          { type: 'p', text: 'Der Zugang zur Website kann jedoch vorübergehend unterbrochen werden, insbesondere aus Gründen der Wartung, Aktualisierung, technischer Probleme oder Umständen, die ausserhalb des Einflussbereichs von Limpia Sàrl liegen.' },
          { type: 'p', text: 'Limpia Sàrl übernimmt keine Gewähr für eine dauerhafte oder unterbrechungsfreie Verfügbarkeit der Website.' },
        ],
      },
      {
        title: '7. Links zu Dritt-Websites',
        blocks: [
          { type: 'p', text: 'Die Website kann Links zu Websites oder Diensten enthalten, die von Dritten betrieben werden.' },
          { type: 'p', text: 'Diese Links werden ausschliesslich aus praktischen oder informativen Gründen bereitgestellt.' },
          { type: 'p', text: 'Limpia Sàrl hat keinerlei Kontrolle über den Inhalt, die Verfügbarkeit oder die Datenschutzpraktiken dieser Dritt-Websites und lehnt jegliche Verantwortung dafür ab.' },
        ],
      },
      {
        title: '8. Haftungsbeschränkung',
        blocks: [
          { type: 'p', text: 'Im Rahmen des anwendbaren Schweizer Rechts lehnt Limpia Sàrl jegliche Haftung für direkte oder indirekte Schäden ab, die aus der Nutzung oder der Unmöglichkeit der Nutzung der Website entstehen können.' },
          { type: 'p', text: 'Limpia Sàrl kann insbesondere nicht für Schäden haftbar gemacht werden, die aus technischen Problemen, Dienstunterbrechungen, Schadsoftware, Datenverlust oder unbefugtem Zugriff Dritter entstehen, sofern keine zwingende gesetzliche Bestimmung etwas anderes vorsieht.' },
          { type: 'p', text: 'Die auf der Website veröffentlichten Informationen stellen keine vertragliche Verpflichtung hinsichtlich einer bestimmten Leistung dar, sofern keine ausdrückliche gegenteilige Vereinbarung besteht.' },
        ],
      },
      {
        title: '9. Datenschutz',
        blocks: [
          { type: 'p', text: 'Die im Zusammenhang mit der Nutzung der Website erfolgende Verarbeitung personenbezogener Daten unterliegt unserer Datenschutzerklärung.' },
          { type: 'p', text: 'Die Nutzer werden gebeten, diese Erklärung zu lesen, um sich über die Erhebung, Verwendung, Speicherung und den Schutz ihrer personenbezogenen Daten zu informieren.' },
        ],
      },
      {
        title: '10. Änderungen der Bedingungen',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen jederzeit zu ändern.' },
          { type: 'p', text: 'Die zum Zeitpunkt des Abrufs auf der Website veröffentlichte Fassung ist massgeblich.' },
        ],
      },
      {
        title: '11. Anwendbares Recht',
        blocks: [
          { type: 'p', text: 'Diese Allgemeinen Geschäftsbedingungen unterliegen dem Schweizer Recht, vorbehaltlich zwingender gesetzlicher Bestimmungen.' },
        ],
      },
      {
        title: '12. Gerichtsstand',
        blocks: [
          { type: 'p', text: 'Vorbehaltlich zwingender gesetzlicher Zuständigkeitsregeln sind für alle Streitigkeiten im Zusammenhang mit der Nutzung der Website die am Sitz von Limpia Sàrl zuständigen Gerichte zuständig.' },
        ],
      },
      {
        title: '13. Kontakt',
        blocks: [
          { type: 'p', text: 'Bei Fragen zu diesen Allgemeinen Geschäftsbedingungen können Sie sich wenden an:' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Schweiz' },
          { type: 'p', text: 'E-Mail: info@limpiasarl.ch' },
          { type: 'p', text: 'Telefon: +41 26 436 10 83 & +41 79 887 72 52' },
        ],
      },
    ],
  },
};